import { Injectable } from '@angular/core';

declare global {
	interface Window {
		pendo: { track: (eventName: string, metadata?: object) => void };
	}
}

@Injectable({
	providedIn: 'root',
})
export class TrackPendoService {
	private pendo = window.pendo;

	track(eventName: string, metadata: object = null): void {
		this.pendo.track(eventName, metadata);
	}
}
